import { isEmpty } from 'lodash-es'

export function getQueryParams(): any {
  const queryString = window.location.search
  if (!queryString) {
    return {}
  }

  const queryParams = queryString
    .substring(1)
    .split('&')
    .reduce((params, param) => {
      const values = param.split('=')
      params[values[0]] = values[1] && decodeURIComponent(values[1])
      return params
    }, {})

  return queryParams
}

export function getQueryParam(paramName) {
  return getQueryParams()[paramName]
}

export function getMockQueryParams() {
  const queryParams = getQueryParams()
  const mockParamKeys = Object.keys(queryParams).filter((key) => key.startsWith('_mock'))
  const mockParams = {}
  mockParamKeys.forEach((key) => {
    mockParams[key] = queryParams[key]
  })

  return mockParams
}

export function appendQueryParams(url, params) {
  if (isEmpty(params)) {
    return url
  }

  const queryParams = []
  for (const key in params) {
    if (params[key]) {
      queryParams.push(`${key}=${encodeURIComponent(params[key])}`)
    }
  }

  if (queryParams.length === 0) {
    return url
  }

  url += url.includes('?') ? '&' : '?'
  url += queryParams.join('&')
  return url
}

export function parseQueryParams(queryString) {
  const queryObj = {}
  if (!queryString) {
    return queryObj
  }
  queryString.split('&').forEach((queryParam) => {
    const [key, value] = queryParam.split('=')
    if (key) {
      queryObj[decodeURIComponent(key)] = value && decodeURIComponent(value)
    }
  })
  return queryObj
}
